import { createCachedApiReducer } from '../../../utils/api-state';
import { CreditScoreHistory } from '../models/credit-health.model';
import { creditHealthActions } from './credit-health.action';

export interface CreditHealth200Error {
  errorMessage?: string;
  errorType?: string;
  stackTrace?: string[];
}

export interface CreditHealthState extends CreditHealth200Error {
  latest_score: number;
  score_history: CreditScoreHistory[];
  tu_feature_toggle: boolean;
}

export const creditHealthReducer = createCachedApiReducer(creditHealthActions);
